import { gql } from "@apollo/client";

export const SUBMIT_CREATOR_APPLICATION = gql`
	mutation SubmitCreatorApplication($input: CreatorApplicationInput!, $captchaToken: String) {
		submitCreatorApplication(input: $input, captchaToken: $captchaToken)
	}
`;
